export default __webpack_public_path__ + "static/splitscreens-bc1232faca8e5ddf4d79d04306bbd664.jpg";